import React from 'react';
import PropTypes from 'prop-types';

const WordCountIndicator = ({ count, limit, over }) => (
  <div className={`mt-1 small ${over ? 'text-danger fw-bold' : 'text-muted'}`}>
    {count} / {limit} words
    {over && (
      <span className="ms-2">
        <i className="fas fa-exclamation-circle me-1" />
        Exceeds limit by {count - limit} words
      </span>
    )}
  </div>
);

WordCountIndicator.propTypes = {
  count: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  over: PropTypes.bool.isRequired,
};

export default WordCountIndicator;
